import Table from 'components/Table';
import useBudgetSettingsColumnSettings from './useBudgetSettingsColumnSettings';
import LoadingSpinner from 'components/spinners/LoadingSpinner';
import { useInternalDeliveryGroupBudgetSettingsFilters } from '../useInternalDeliveryGroupBudgetSettingsFilters';
import { useInternalDeliveryBudgetGetWeeklyBudgetsOfMonth } from 'api/internal-delivery-budget/internal-delivery-budget';

const InternalDeliveryGroupBudgetSettingsTable = () => {
  const { state: filterState } =
    useInternalDeliveryGroupBudgetSettingsFilters();

  const getBudgets = useInternalDeliveryBudgetGetWeeklyBudgetsOfMonth({
    date: filterState.selectedDate,
  });

  const columnSettings = useBudgetSettingsColumnSettings(getBudgets);

  return (
    <>
      {getBudgets.isLoading && <LoadingSpinner />}
      {getBudgets.isSuccess && (
        <Table
          columnSettings={columnSettings}
          rows={getBudgets.data}
          fluid
          useColumnWidthAsFlexAmount
        />
      )}
    </>
  );
};

export default InternalDeliveryGroupBudgetSettingsTable;
